import "../App.css";
import HeroSection from '../components/HeroSection'
import Cards from '../components/Cards'
import Header from '../components/Header'
function HomePage() {
  return (
    <>
        <HeroSection/>
        <Header/>
        {/* <Cards /> */}
    </>
  );
}

export default HomePage;
